import { render, staticRenderFns } from "./ProjectBar.vue?vue&type=template&id=77c70209&"
import script from "./ProjectBar.vue?vue&type=script&lang=ts&"
export * from "./ProjectBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports